import * as TYPES from './types';
export default {
  [TYPES.SET_CURRENT_IMAGE](state, image) {
    const currentState = state;
    currentState.currentImage = image;
  },

  [TYPES.RESET_CURRENT_IMAGE](state) {
    const currentState = state;
    currentState.currentImage = null;
  },

  [TYPES.SET_PRODUCT_CAROUSELS](state, product) {
    const currentState = state;
    currentState.productCross = product.cross;
    currentState.productComplementary = product.complementary;
  },

  [TYPES.SET_PRODUCT](state, product) {
    const currentState = state;
    currentState.productCross = product.cross;
    currentState.productInspiration = product.inspiration;
    currentState.productComplementary = product.complementary;
    currentState.product = product;
    currentState.variants = product.variants || [];
  },

  [TYPES.SET_PRODUCT_IMAGES](state, _ref) {
    let {
      images
    } = _ref;
    state.images = images;
  },

  [TYPES.RESET_PRODUCT](state) {
    const currentState = state;
    currentState.productCross = null;
    currentState.productComplementary = null;
    currentState.productInspiration = null;
    currentState.product = null;
    currentState.images = [];
    currentState.variants = [];
  }

};